query GetRole($id: ID!) {
  role(id: $id) {
    id
    name
    permissions {
      id
      name
    }
  }
}
